import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { TypographyH4White } from '../../../features/estimatingRequirements/peng2018/style';

export const BMICard = ({
  label1,
  label2,
  icon,
  unit
}: {
  label1: string;
  label2: string;
  icon: any;
  unit?: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '98%',
        height: '120px',
        backgroundColor: '#004F71',
        borderRadius: '0.9375rem',
        paddingBottom: '0.9375rem'
      }}
    >
      {/* code for circle with 45px width and height with bg color as yellow */}
      <Box
        sx={{
          width: '45px',
          height: '45px',
          backgroundColor: '#004F71',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '0.3125rem solid #FFF',
          position: 'relative',
          top: '-1.5625rem'
        }}
      >
        <img src={icon} alt="scale" />
      </Box>

      {label1 && (
        <TypographyH4White
          variant="h4"
          sx={{ fontSize: '0.875rem', color: '#fff', lineHeight: '0px' }}
        >
          {label1}
        </TypographyH4White>
      )}
      {label2 && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '35px',
            color: '#fff',
            lineHeight: '3.125rem',
            whiteSpace: 'nowrap'
          }}
        >
          {label2 !== 'NA' ? (
            label2
          ) : (
            <div style={{ marginTop: '0.625rem' }}>{label2}</div>
          )}
          {unit && label2 !== 'NA' && (
            <span dangerouslySetInnerHTML={{ __html: unit }}></span>
          )}
        </Typography>
      )}
    </Box>
  );
};
